import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import './EtchVisualNavigationStory.scss';
import VideoPlayer from '../VideoPlayer/VideoPlayer.component';
import { getVideoId } from '../../helpers/helpers';

const EtchVisualNavigationStory = (props) => {

  const opts = props?.opts;
  const {
    ctaLink = '',
    type,
    image = {},
    heading,
    subHeading,
    linkList,
    id
  } = opts;
  const { src, alt, height, width } = image;
  const imgClass = classNames({
    'img--block': height && width
  });

  const videoId = getVideoId(ctaLink)

  return (
    <>
      <div className="etchVisualNavigationStory etch-analytics" data-module-id={id} data-module-type={type}>
        <div className="etchVisualNavigationStory__container">
          <div className="etchVisualNavigationStory__card" data-module-content-id={id}>
            {ctaLink
              && (
                videoId ?
                  <>
                    <VideoPlayer videoId={videoId}>
                      <Image
                        className={`etchVisualNavigationStory__card__img ${imgClass}`}
                        lazy
                        src={src}
                        alt={alt}
                        height={height}
                        width={width}
                      />
                      <span className="etchVisualNavigationStory__card__title">
                        {heading}
                      </span>
                      <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                    </VideoPlayer>
                  </> :
                  <>
                    <a href={ctaLink}>
                      <Image
                        className={`etchVisualNavigationStory__card__img ${imgClass}`}
                        lazy
                        src={src}
                        alt={alt}
                        height={height}
                        width={width}
                      />
                    </a>
                    <a href={ctaLink} className="etchVisualNavigationStory__card__title">
                      {heading}
                    </a>
                    <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                  </>
              )}
            {!ctaLink
              && (
                <>
                  <Image
                    className={`etchVisualNavigationStory__card__img ${imgClass}`}
                    lazy
                    src={src}
                    alt={alt}
                    height={height}
                    width={width}
                  />
                  <p className="etchVisualNavigationStory__card__title">{heading}</p>
                  <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                </>
              )}
            {linkList?.length > 0
              && (
                <ul className="etchVisualNavigationStory__link list list--type-plain" data-module-content-id={id}>
                  {linkList.map((links, index) => {
                    const { link, linkText } = links;
                    const video_id = getVideoId(link);
                    return (
                      <React.Fragment key={`${index}-${linkText}`}>
                        {
                          link ?
                            <li className="list__item">
                              {
                                video_id ? <VideoPlayer className="list__link" videoId={video_id}>
                                  {linkText}
                                </VideoPlayer>
                                  :
                                  <a className="list__link" href={link}>{linkText}</a>
                              }
                            </li> :
                            (
                              <li className="list__item">
                                {linkText}
                              </li>
                            )
                        }

                      </React.Fragment>
                    );
                  })}
                </ul>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

EtchVisualNavigationStory.displayName = 'EtchVisualNavigationStory';

EtchVisualNavigationStory.propTypes = {
  opts: PropTypes.shape({
    ctaLink: PropTypes.string,
    type: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    linkList: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string
    })),
    id: PropTypes.string
  })
};

EtchVisualNavigationStory.defaultProps = {
  opts: {}
};

export default EtchVisualNavigationStory;
